import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import lightLogo from "../../../../img/logo-light.png";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import ResetPasswordLoader from "../change-details-loader";

import "react-toastify/dist/ReactToastify.css";
import "./style.scss";

const Index = () => {
  const [firstPassword, setFirstPassword] = useState(null);
  const [secondPassword, setSecondPassword] = useState(null);

  const validateLoading = useSelector(
    (state) => state.resetPassword.validateResetCodeLoading
  );
  const validateSuccess = useSelector(
    (state) => state.resetPassword.validateResetCodeStatus
  );

  return (
    <section className="reset-password-page-section">
      <div className="inner-reset-password-page-container">
        <div className="full-content-container">
          <div className="reset-password-display-container">
            <div className="reset-password-box-container">
              <div className="inner-reset-password-box-container">
                <Link to="/">
                  <img
                    alt="Leadfind logo"
                    className="reset-password-logo"
                    src={lightLogo}
                  />
                </Link>
                <h3 className="reset-password-title">Sett nytt passord</h3>
                <div className="reset-password-display-container">
                  {validateSuccess ? (
                    <div className="success-container">
                      <h3 className="success-title">
                        Passordet ditt ble oppdatert, du kan nå logge inn med
                        det nye passordet du har lagt inn.
                      </h3>
                    </div>
                  ) : (
                    <>
                      <div className="input-group">
                        <label>Passord</label>
                        <input
                          name="password"
                          placeholder="Passord"
                          disabled={validateLoading ? true : false}
                          onChange={(e) => setFirstPassword(e.target.value)}
                          value={firstPassword}
                          type="password"
                        />
                      </div>
                      <div className="input-group">
                        <label>Passord igjen</label>
                        <input
                          name="password"
                          placeholder="Passord"
                          disabled={validateLoading ? true : false}
                          onChange={(e) => setSecondPassword(e.target.value)}
                          value={secondPassword}
                          type="password"
                        />
                      </div>
                    </>
                  )}
                  <div className="button-container">
                    {validateSuccess ? (
                      <Link to="/logg-inn">
                        <button className="login-button">
                          Gå tilbake til innlogging
                        </button>
                      </Link>
                    ) : (
                      <button className="login-button">
                        {validateLoading ? (
                          <i className="fas fa-circle-notch fa-spin"></i>
                        ) : null}{" "}
                        {validateLoading
                          ? "Oppdaterer passord.."
                          : "Oppdater passord"}
                      </button>
                    )}
                  </div>
                  <div className="sign-up-container">
                    <p className="signup-label">
                      Ikke behov for å tilbakestille?{" "}
                      <Link to="/logg-inn">Klikk her</Link>.
                    </p>
                  </div>
                </div>
              </div>
              {validateLoading ? <ResetPasswordLoader /> : null}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default withRouter(Index);
